// Silences uncaught errors that originate from browser extensions
// (MetaMask, wallet connectors, ad-blockers, password managers, etc.).
// They surface in CRA's dev overlay and in prod error reporting even though
// they come from scripts injected into the page by extensions, not from our app.

const EXTENSION_SOURCES = [
  "chrome-extension://",
  "moz-extension://",
  "safari-extension://",
  "safari-web-extension://",
  "ms-browser-extension://",
  "edge-extension://",
];

const EXTENSION_SIGNATURES = [
  "Failed to connect to MetaMask",
  "MetaMask",
  "inpage.js",
  "contentscript.js",
  "web3",
  "ethereum",
];

function looksLikeExtensionNoise(value) {
  if (value == null) return false;
  const s = typeof value === "string" ? value : String(value);
  return (
    EXTENSION_SOURCES.some((p) => s.includes(p)) ||
    EXTENSION_SIGNATURES.some((sig) => s.includes(sig))
  );
}

function isExtensionErrorEvent(event) {
  if (!event) return false;
  if (looksLikeExtensionNoise(event.filename)) return true;
  if (looksLikeExtensionNoise(event.message)) return true;
  const err = event.error || event.reason;
  if (err) {
    if (looksLikeExtensionNoise(err.message)) return true;
    if (looksLikeExtensionNoise(err.stack)) return true;
    if (looksLikeExtensionNoise(err.name)) return true;
  }
  return false;
}

export function installExtensionErrorFilter() {
  if (typeof window === "undefined") return;

  const swallow = (event) => {
    if (isExtensionErrorEvent(event)) {
      // Prevent dev-overlay + default logging; the extension error is not ours.
      event.stopImmediatePropagation?.();
      event.preventDefault?.();
      return false;
    }
    return undefined;
  };

  // Capture-phase so we fire before React/CRA's listeners.
  window.addEventListener("error", swallow, true);
  window.addEventListener("unhandledrejection", swallow, true);

  // Also tame console.error noise from the same source.
  const origError = console.error;
  console.error = function patchedConsoleError(...args) {
    if (args.some(looksLikeExtensionNoise)) return;
    origError.apply(console, args);
  };
}
